import * as React from 'react';
import { handleSilentRenew } from '../../helpers/asureid';

const SilentRenewPage: React.FC = () => {
  React.useEffect(() => {
    handleSilentRenew();
  }, []);

  return null; // Silent renew should not render anything
};

export default SilentRenewPage;
